import React, { Fragment } from "react";
import { Header, Footer } from "../components/opencoin-ui";
import { NavLink } from "react-router-dom";
import {
  RiDiscordLine,
  RiMediumLine,
  RiShoppingCart2Line,
  RiTelegramLine,
  RiTwitterLine,
} from "react-icons/ri";
import { useTranslation } from "react-i18next";
export default function Home() {
  const { t } = useTranslation();
  return (
    <>
      <Header />
      <section className="relative px-4 py-4 overflow-hidden bg-white md:px-12 lg:px-28 dark:bg-grayc-950 md:py-20 lg:py-20 font-body">
        <div className="space-y-5">
          <h1 className="text-3xl font-bold text-center text-transparent md:text-5xl lg:text-5xl xl:text-5xl bg-gradient-to-r from-yellow-500 via-orange-500 to-red-500 bg-clip-text">
            {t("banner title")}
          </h1>
          <h2 className="text-3xl font-bold leading-tight text-center text-gray-900 md:leading-tight lg:leading-tight xl:leading-tight md:text-5xl lg:text-5xl xl:text-5xl dark:text-white">
            {t("banner subtitle")} <br /> {t("banner subtitle 2")}
          </h2>

          <p className="text-xl text-center text-gray-800 dark:text-gray-400">
            {t("banner description")}
          </p>
          <div className="flex justify-center gap-5">
            <NavLink
              to="/staking"
              className="px-8 py-4 text-white bg-yellow-600 hover:bg-yellow-700 rounded-2xl"
            >
              {t("launch app")}
            </NavLink>
            <NavLink
              to="/opc-stake"
              className="px-8 py-4 text-gray-900 bg-gray-300 dark:bg-gray-700 dark:text-gray-200 hover:bg-gray-400 rounded-2xl"
            >
              {t("opc stake")}
            </NavLink>
          </div>
        </div>
      </section>
      <section className="relative px-4 py-4 overflow-hidden bg-gray-100 md:px-12 lg:px-28 dark:bg-grayc-950 md:py-20 lg:py-20 font-body">
        <div className="p-12 mb-16 bg-white md:p-16 lg:p-16 xl:p-16 rounded-3xl dark:bg-gray-700">
          <div className="flex items-center justify-between w-full">
            <div className="mb-3 text-2xl font-semibold text-yellow-600">
              {t("for stakers")}
            </div>
            <div>
              <img
                src="/images/illustration/shape.png"
                className="absolute -mt-32 -ml-16"
                width="150"
                height="150"
                alt="shape"
              />
            </div>
          </div>
          <h1 className="text-3xl font-bold leading-tight text-gray-900 md:text-5xl lg:text-5xl xl:text-5xl dark:text-white">
            {t("staker title")} <br /> {t("staker title 2")}
          </h1>
          <hr className="my-6" />
          <div className="flex flex-col justify-between w-full md:flex-row lg:flex-row xl:flex-row">
            <div className="text-xl font-semibold text-black dark:text-white">
              <span className="text-xl font-semibold text-yellow-700">1. </span>
              {t("buy token")}
            </div>
            <div className="text-xl font-semibold text-black dark:text-white">
              <span className="text-xl font-semibold text-yellow-700">2. </span>
              {t("stake your token")}
            </div>
            <div className="text-xl font-semibold text-black dark:text-white">
              <span className="text-xl font-semibold text-yellow-700">3. </span>
              {t("share your referral")}
            </div>
          </div>
        </div>
        <div className="p-12 mb-16 bg-white md:p-16 lg:p-16 xl:p-16 rounded-3xl dark:bg-gray-700">
          <div className="flex items-center justify-between w-full">
            <div className="mb-3 text-2xl font-semibold text-yellow-600">
              {t("about us")}
            </div>
            <div>
              <img
                src="/images/illustration/opencoin.png"
                className="absolute -mt-32 -ml-16"
                width="180"
                height="180"
                alt="shape"
              />
            </div>
          </div>
          <h1 className="text-3xl font-bold leading-tight text-gray-900 md:text-5xl lg:text-5xl xl:text-5xl dark:text-white">
            {t("opencoin title")}
          </h1>
          <h2 className="my-5 text-xl text-black dark:text-white">
            {t("opencoin description")}
          </h2>
          <hr className="my-6 text-black dark:text-gray-500" />
          <div className="flex justify-end w-full">
            <a
              href="https://www.okx.com/web3/dex-swap?inputChain=56&inputCurrency=0x55d398326f99059ff775485246999027b3197955&outputChain=56&outputCurrency=0x1f19c26a7f9b7a673348258d2fef0b7df1edef32"
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-2 px-8 py-4 text-white bg-yellow-600 hover:bg-yellow-700 rounded-2xl"
            >
              <RiShoppingCart2Line /> {t("buy coin")}
            </a>
          </div>
        </div>

        <div className="p-12 mb-16 bg-white md:p-16 lg:p-16 xl:p-16 rounded-3xl dark:bg-gray-700">
          <div className="mb-3 text-2xl font-semibold text-yellow-600">
            {t("token information")}
          </div>
          <h1 className="text-3xl font-bold leading-tight text-gray-900 md:text-5xl lg:text-5xl xl:text-5xl dark:text-white">
            {t("opencoin token information")}
          </h1>
          <div className="flex items-center justify-between w-full mt-12">
            <div className="space-y-4">
              <h1 className="text-xl font-semibold text-black dark:text-white">
                Name: OpenCoin
              </h1>
              <h1 className="text-xl font-semibold text-black dark:text-white">
                Symbol: OPC
              </h1>
              <h1 className="text-xl font-semibold text-black dark:text-white">
                Decimals: 18
              </h1>
            </div>
            <img
              src="/images/illustration/opencoin-front.png"
              className=""
              width="180"
              height="180"
              alt="shape"
            />
            <div className="space-y-4">
              <h1 className="text-xl font-semibold text-black dark:text-white">
                Supply: 1.000.000
              </h1>
              <h1 className="text-xl font-semibold text-black dark:text-white">
                Network: Binance Smart Chain
              </h1>
            </div>
          </div>
          <hr className="my-6 text-black dark:text-gray-500" />
          <div className="flex justify-end w-full">
            <a
              href="https://www.okx.com/web3/dex-swap?inputChain=56&inputCurrency=0x55d398326f99059ff775485246999027b3197955&outputChain=56&outputCurrency=0x1f19c26a7f9b7a673348258d2fef0b7df1edef32"
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-2 px-8 py-4 text-white bg-yellow-600 hover:bg-yellow-700 rounded-2xl"
            >
              <RiShoppingCart2Line /> {t("buy coin")}
            </a>
          </div>
        </div>

        <div className="p-12 mb-16 bg-white md:p-16 lg:p-16 xl:p-16 rounded-3xl dark:bg-gray-700">
          <div className="flex items-center justify-between w-full">
            <div className="mb-3 text-2xl font-semibold text-yellow-600">
              {t("token allocation")}
            </div>
            <div>
              <img
                src="/images/illustration/allocation.png"
                className="absolute -mt-32 -ml-16"
                width="180"
                height="180"
                alt="shape"
              />
            </div>
          </div>
          <h1 className="mb-12 text-3xl font-bold leading-tight text-gray-900 md:text-5xl lg:text-5xl xl:text-5xl dark:text-white">
            {t("token allocation")}
          </h1>
          <h2 className="my-5 text-xl text-black dark:text-white">
            <div className="overflow-y-scroll">
              <table className="table-auto w-full">
                <tbody className="text-sm divide-y divide-gray-100">
                  <tr>
                    <td className="p-2 whitespace-nowrap">
                      <div className="text-lg text-left">
                        {t("private sale")} 200.000 OPC
                      </div>
                    </td>
                    <td className="p-2 whitespace-nowrap">
                      <div className="text-lg text-left">
                        {t("selling angels")} 100.000 OPC
                      </div>
                    </td>
                    <td className="p-2 whitespace-nowrap">
                      <div className="text-lg text-left">
                        {t("open pool")} 400.000 OPC
                      </div>
                    </td>
                    <td className="p-2 whitespace-nowrap">
                      <div className="text-lg text-left">
                        {t("open cloud")} 100.000 OPC
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="p-2 whitespace-nowrap">
                      <div className="text-lg text-left">
                        {t("open team")} 100.000 OPC
                      </div>
                    </td>
                    <td className="p-2 whitespace-nowrap">
                      <div className="text-lg text-left">
                        {t("airdrop")} 1.000 OPC
                      </div>
                    </td>
                    <td className="p-2 whitespace-nowrap">
                      <div className="text-lg text-left">
                        {t("ecosystem")} 20.000 OPC
                      </div>
                    </td>
                    <td className="p-2 whitespace-nowrap">
                      <div className="text-lg text-left">
                        {t("mining")} 20.000 OPC
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="p-2 whitespace-nowrap">
                      <div className="text-lg text-left">
                        {t("marketing")} 9.000 OPC
                      </div>
                    </td>
                    <td className="p-2 whitespace-nowrap">
                      <div className="text-lg text-left">
                        {t("cex")} 40.000 OPC
                      </div>
                    </td>
                    <td className="p-2 whitespace-nowrap">
                      <div className="text-lg text-left">
                        {t("partnership")} 10.000 OPC
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </h2>
          <hr className="my-6 text-black dark:text-gray-500" />
          <div className="flex justify-end w-full">
            <a
              href="https://www.okx.com/web3/dex-swap?inputChain=56&inputCurrency=0x55d398326f99059ff775485246999027b3197955&outputChain=56&outputCurrency=0x1f19c26a7f9b7a673348258d2fef0b7df1edef32"
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-2 px-8 py-4 text-white bg-yellow-600 hover:bg-yellow-700 rounded-2xl"
            >
              <RiShoppingCart2Line /> {t("buy coin")}
            </a>
          </div>
        </div>
        <div className="p-12 mb-16 md:p-16 lg:p-16 xl:p-16 rounded-3xl">
          <h2 className="mb-12 text-5xl font-bold leading-tight text-center text-gray-900 dark:text-white">
            {t("join community")}
          </h2>
          <div className="grid grid-cols-1 gap-6 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-4">
            <a
              href="https://"
              className="p-6 bg-white rounded-xl hover:bg-yellow-500 hover:text-black dark:bg-gray-700 dark:text-white"
            >
              <h1 className="text-lg font-bold">Twitter</h1>
              <h2 className="my-3 text-gray-700 dark:text-gray-500">
                {t("general announcements")}
              </h2>
              <div className="flex justify-end">
                <RiTwitterLine className="text-3xl" />
              </div>
            </a>
            <a
              href="https://"
              className="p-6 bg-white rounded-xl hover:bg-yellow-500 hover:text-black dark:bg-gray-700 dark:text-white"
            >
              <h1 className="text-lg font-bold">Telegram</h1>
              <h2 className="my-3 text-gray-700 dark:text-gray-500">
                {t("general announcements")}
              </h2>
              <div className="flex justify-end">
                <RiTelegramLine className="text-3xl" />
              </div>
            </a>
            <a
              href="https://"
              className="p-6 bg-white rounded-xl hover:bg-yellow-500 hover:text-black dark:bg-gray-700 dark:text-white"
            >
              <h1 className="text-lg font-bold">Discord</h1>
              <h2 className="my-3 text-gray-700 dark:text-gray-500">
                {t("general announcements")}
              </h2>
              <div className="flex justify-end">
                <RiDiscordLine className="text-3xl" />
              </div>
            </a>
            <a
              href="https://"
              className="p-6 bg-white rounded-xl hover:bg-yellow-500 hover:text-black dark:bg-gray-700 dark:text-white"
            >
              <h1 className="text-lg font-bold">Medium</h1>
              <h2 className="my-3 text-gray-700 dark:text-gray-500">
                {t("general announcements")}
              </h2>
              <div className="flex justify-end">
                <RiMediumLine className="text-3xl" />
              </div>
            </a>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
